import moment from 'moment-timezone'

export default {
  SET_ASSOCIATE: (state, payload) => {
    const now = moment().utc().startOf('day')
    const associate = payload

    const isInTrainingPeriod = () => {
      if (!associate?.training_started_at) return false

      const start = moment(associate.training_started_at).utc().startOf('day')
      const end = associate.training_ended_at ? moment(associate.training_ended_at).utc().startOf('day') : null

      if (end) {
        return now.isBetween(start, end, 'day', '[]')
      }

      return now.isSameOrAfter(start, 'day')
    }

    state.associate = {
      ...payload,
      is_in_training_period: isInTrainingPeriod()
    }
  },
  SET_ASSOCIATE_CHANGES_HISTORY: (state, payload) => (state.associateChangesHistory = payload),
  SET_ASSOCIATE_COMPLIANCE: (state, payload) => (state.associateCompliance = payload),
  SET_ASSOCIATE_FACILITIES: (state, payload) => (state.associateFacilities = payload),
  SET_ASSOCIATE_CERTIFICATION: (state, payload) => (state.associateCertification = payload),
  SET_ASSOCIATE_COMPANY_FLOW: (state, payload) => (state.associateCompanyFlow = payload),
  SET_ASSOCIATE_LIFECYCLE_EVENTS: (state, payload) => (state.associateLifecycleEvents = payload),
  setAssociateKPI: (state, payload) => (state.associateKPI = payload),
  setAssociateAttendanceRate: (state, payload) => (state.associateAttendanceRate = payload),
  setAssociateWriteUps: (state, payload) => (state.associateWriteUps = payload),
  setSignedDocuments: (state, payload) => (state.signedDocuments = payload),
  setRefetchAssociate: (state, payload) => (state.refetchAssociate = payload),
  setManagerScopeObjects: (state, payload) => (state.managerScopeObjects = payload)
}
